import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#1D9BF0',
      light: '#1A8CD8',
      dark: '#0A0A0A',
    },
    secondary: {
      main: '#1A1A1A',
    },
    background: {
      default: '#000000',
      paper: '#0A0A0A',
    },
    text: {
      primary: '#E7E9EA',
      secondary: '#8A8A8A',
    },
  },
  typography: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    h1: {
      fontSize: '3rem',
      fontWeight: 800,
      letterSpacing: '-0.025em',
      color: '#E7E9EA',
    },
    h2: {
      fontSize: '2.25rem',
      fontWeight: 700,
      letterSpacing: '-0.025em',
      color: '#E7E9EA',
    },
    h3: {
      fontSize: '1.875rem',
      fontWeight: 600,
      color: '#E7E9EA',
    },
    body1: {
      fontSize: '1.125rem',
      fontWeight: 400,
      color: '#C7CDD3',
      lineHeight: 1.6,
    },
    button: {
      textTransform: 'none',
      fontWeight: 700,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 2,
          textTransform: 'none',
          fontWeight: 700,
          padding: '12px 24px',
        },
        containedPrimary: {
          backgroundColor: '#1D9BF0',
          '&:hover': {
            backgroundColor: '#1A8CD8',
          },
        },
        outlinedPrimary: {
          borderColor: '#1D9BF0',
          color: '#1D9BF0',
          '&:hover': {
            borderColor: '#1A8CD8',
            backgroundColor: 'rgba(29, 155, 240, 0.1)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: '#16202A',
          border: '1px solid #2F3336',
          borderRadius: 3,
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
        },
      },
    },
  },
});

export default theme;